import React, { createContext, useReducer } from 'react'

export const SET_SALES_CODE_PLUGIN_DATA = 'SET_SALES_CODE_PLUGIN_DATA'
export const UPDATE_SALES_CODE_PLUGIN_DATA = 'UPDATE_SALES_CODE_PLUGIN_DATA'
export const SET_SELECTED_SALES_CODE_PLUGIN_DATA =
  'SET_SELECTED_SALES_CODE_PLUGIN_DATA'
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS'
export const SET_SHOW_HIDE_FORM_POPUP = 'SET_SHOW_HIDE_FORM_POPUP'
export const SET_SHOW_HIDE_DETAILS_POPUP = 'SET_SHOW_HIDE_DETAILS_POPUP'
export const SET_UPLOAD_FILE_STATUS = 'SET_UPLOAD_FILE_STATUS'
export const SET_SHOW_HIDE_ERROR_LOGS = 'SET_SHOW_HIDE_ERROR_LOGS'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_SALES_CODE_PLUGIN_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_SALES_CODE_PLUGIN_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case SET_SELECTED_SALES_CODE_PLUGIN_DATA: {
      return { ...data, selectedObject: payload.data }
    }
    case SET_SELECTED_IDS: {
      let tempSelectedIds = [...data.selectedIds]
      let item = payload.data
      tempSelectedIds.indexOf(item) === -1
        ? tempSelectedIds.push(item)
        : tempSelectedIds.splice(tempSelectedIds.indexOf(item), 1)
      return { ...data, selectedIds: tempSelectedIds }
    }
    case SET_SHOW_HIDE_FORM_POPUP: {
      return { ...data, showUploadPopup: payload.data }
    }
    case SET_SHOW_HIDE_DETAILS_POPUP: {
      return { ...data, showDetailsPopup: payload.data }
    }
    case SET_UPLOAD_FILE_STATUS: {
      return {
        ...data,
        in_process_upload_files: payload.data.in_process_upload_files,
      }
    }
    case SET_SHOW_HIDE_ERROR_LOGS: {
      return { ...data, showErrorPopup: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
  selectedIds: [],
  showUploadPopup: false,
  showDetailsPopup: false,
  in_process_upload_files: false,
  showErrorPopup: false,
}

const SalesCodeComplexityStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <SalesCodeComplexityContext.Provider value={[state, dispatch]}>
      {children}
    </SalesCodeComplexityContext.Provider>
  )
}

export const SalesCodeComplexityContext = createContext(initialState)
export default SalesCodeComplexityStore
